import React from 'react';
import { FiArrowLeft } from 'react-icons/fi';

const PrivacyPolicy = () => {
  return (
    <div className="sm:min-h-full sm:pb-10 lg:pb-10 md:pb-10  xl:pb-10 xs:pt-4 sm:pt-4 xs:pb-10 xs:min-h-full  min-h-screen flex flex-col">

    <div className='w-full py-10  xl:px-[10%] lg:px-[8%] xs:px-[5%] md:px-[6%] sm:px-[5%]  px-6  pt-10'>
    <a href="/"
                       
                       className="text-black hover:text-gray-600 transition"
                     >
                       <FiArrowLeft size={24} />
                     </a>
    <div className="flex items-center justify-center gap-2 xs:justify-start xs:px-4">
         
          <h1 className="text-[40px] xs:text-[16px] font-semibold font-inter text-black">Privacy Policy</h1>
        </div>

      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        <strong className='text-[20px] md:sm:text-[16px] xs:text-[15px]' >Introduction</strong><br />
        Welcome to Drunkmates. Your privacy is critically important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our Android application that blocks other apps and calls on your device.
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">1. Information We Collect</h2>

      <p className="mb-2 text-[20px] md:sm:text-[16px] xs:text-[15px]"><strong>1.1 Personal Information</strong></p>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        We may collect and process the following types of information:
        <ul className="list-disc list-inside ml-4">
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Gender</li>
        </ul>
        We use the information we collect for the following purposes:
        <ul className="list-disc list-inside ml-4">
          <li>To improve and personalize your experience</li>
          <li>To communicate with you, including sending updates and promotional materials</li>
          <li>To ensure the safety and security of our App and users</li>
        </ul>
      </p>

      <p className="mb-2 text-[20px] md:sm:text-[16px] xs:text-[15px]"><strong>1.2 Non-Personal Information</strong></p>
      <p className="mb-4">
        When you use our app, we may collect non-personal information such as device information (e.g., device model, operating system version), app usage data, and log information. This data is used to improve the functionality and performance of our app.
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">2. How We Use Information</h2>
      <p className="mb-2 text-[20px] md:sm:text-[16px] xs:text-[15px]"><strong>2.1 Blocking Features</strong></p>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        The primary purpose of our app is to block other apps and calls as per user settings. The information collected is used solely to enable and optimize these features.
      </p>

      <p className="mb-2 text-[20px] md:sm:text-[16px] xs:text-[15px]"><strong>2.2 Improving Our App</strong></p>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        Non-personal information is used to analyze trends, administer the app, track users' movements around the app, and gather demographic information. This information helps us to understand how our users use the app and how we can improve their experience.
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">3. Data Security</h2>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        We are committed to ensuring that your information is secure. We implement appropriate technical and organizational measures to protect the information we collect from unauthorized access, use, or disclosure.
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">4. Sharing Information</h2>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        We do not sell, trade, or otherwise transfer your information to outside parties. This includes both personal and non-personal information.
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">5. Third-Party Services</h2>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        Our app does not currently integrate with any third-party services that may collect information from you.
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">6. User Control</h2>
      <p className="mb-2 text-[20px] md:sm:text-[16px] xs:text-[15px] font-inter"><strong>6.1 Permissions</strong></p>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        Our app may request certain permissions to function correctly (e.g., access to block calls and other apps). You have the option to grant or deny these permissions. However, denying permissions may affect the app's functionality.
      </p>

      <p className="mb-2 text-[20px] md:sm:text-[16px] xs:text-[15px] font-inter"><strong>6.2 Sensitive Permissions</strong></p>
      <ul className="list-disc list-inside mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        <li >
          <strong className='xs:flex xs:flex-wrap xsmax-w-[60%]'>android.permission. <br className='hide xs:block'/> PROCESS_OUTGOING_CALLS:</strong> This permission allows the app to monitor, redirect, or block outgoing calls made from your device. We use this permission solely for the purpose of providing the core functionality of the app.
        </li>
        <li>
          <strong>Blocking Other Apps:</strong> The app may require access to block certain apps as part of its functionality. We use this access strictly for the purpose of providing the service.
        </li>
      </ul>

      <p className="mb-2 text-[20px] md:sm:text-[16px] xs:text-[15px]"><strong>6.3 Opt-Out</strong></p>
      <p className="mb-4">
        You can uninstall our app at any time to stop all data collection and use by the app.
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">7. Changes to This Privacy Policy</h2>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">8. Contact Us</h2>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        If you have any questions about this Privacy Policy, please contact us at:<br />
        <strong>Drunkmates LLC</strong><br />
        Christophar Devis<br />
        <a href="mailto:chris@drunkmates.com" className="text-blue-600 underline">chris@drunkmates.com</a>
      </p>

      <h2 className="text-[25px] font-semibold mt-6 mb-2">9. Consent</h2>
      <p className="mb-4 text-[20px] md:sm:text-[16px] xs:text-[15px]">
        By using our app, you hereby consent to our Privacy Policy and agree to its terms.
      </p>
    </div>
    </div>

  );
};

export default PrivacyPolicy;
